<!--  -->
<template>
  <div class="wrap_bg">
    <div class="boxtype_ban" v-show="boxtype">
      <div class="boxtype_ban_title">重要通知</div>
      <div class="boxtype_content">
        <p>
          1、尊敬的用户，是时候升级您的浏览器了：<br />由于您当前的浏览器版本过低，存在安全风险。根据浏览器厂商版本功能及安全策略，为保障您的使用安全，爱恋珠宝战略资源中心对支持的浏览器版本进行入下调整，建议您尽快更新，以便享受更优质的服务。
        </p>
        <p>
          2、您可以根据您的电脑操作系统，选择以下浏览器登录访问。<br />Windows操作系统：Chrome浏览器<br />MAC
          OS操作系统：Safari7以上版本浏览器
        </p>
        <div style="margin-top: 70px; text-align: center">
          <el-button type="primary" style="width: 50%" @click="downloadbox"
            >chrome下载</el-button
          >
        </div>
      </div>
    </div>
    <div class="img-bg">
      <transition name="el-zoom-in-top">
        <div v-show="show" class="bg_top"></div>
      </transition>
      <transition name="el-zoom-in-bottom">
        <div v-show="show" class="bg_bottom"></div>
      </transition>
      <div>
        <!-- <div class="title">零售系统</div>
        <div class="nav-bg">
          <div class="nav-movebox" :class="isactive"></div>
					<a class="btn firstb" :class="isactive" >老版零售系统</a>
					<a class='btn' :href="loginUrl2020" @mouseenter="enter()" @mouseleave="leave()" target="_blank">新版零售系统</a>
				</div>  -->
        <transition name="el-zoom-in-center">
          <div v-show="show2" class="center_contentBox">
            <div class="login_content">
              <div class="banbenbox">
                <span>vn:202007291030</span>
                <span style="float: right">服务器时间:{{ datatime }}</span>
              </div>
              <!-- 正常登录页 -->
              <transition name="el-zoom-in-center">
                <div class="login_normal" v-show="login_normal">
                  <!-- <div class="codemazheban">
										目前暂未开放使用
									</div> -->
                  <div class="clo_code">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="扫码登录更便捷"
                      placement="left-start"
                    >
                      <div @click="turn_scand">
                        <img src="../assets/half_code.png" alt="" />
                      </div>
                      <!-- @click="show_codes"  -->
                    </el-tooltip>
                  </div>
                  <div class="clo_login_title">密码登录</div>
                  <el-form
                    class="form1"
                    ref="ruleFormLogin"
                    :model="ruleFormLogin"
                    :rules="RulesLogin"
                  >
                    <div>
                      <el-form-item prop="userno">
                        <el-input
                          placeholder="用户名/电话"
                          v-model="ruleFormLogin.userno"
                          clearable
                        >
                          <template slot="prepend"
                            ><img src="../assets/user.png" alt=""
                          /></template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="login_paw">
                      <el-form-item prop="userpwd">
                        <el-input
                          placeholder="密码"
                          v-model="ruleFormLogin.userpwd"
                          type="password"
                          clearable
                        >
                          <template slot="prepend"
                            ><img src="../assets/password.png" alt=""
                          /></template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="login_btn">
                      <el-button
                        style="border: 1px solid #4ebbd0"
                        type="primary"
                        :loading="loginloading"
                        v-loading="loginloading"
                        @click="password_login('ruleFormLogin')"
                        >登录</el-button
                      >
                    </div>
                  </el-form>
                  <p class="forgert_box">
                    <span @click="turn_forgerpaw">忘记密码？</span>
                  </p>
                </div>
              </transition>
              <!-- 扫码登录的页面 -->
              <transition name="el-zoom-in-center">
                <div class="login_sandcode" v-show="login_scandnormal">
                  <!-- <img src="../assets/登录.png" alt=""> -->
                  <div class="clo_code">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="密码登录暂未开放"
                      placement="left-start"
                    >
                      <div @click="turn_paw">
                        <img src="../assets/paw.png" alt="" />
                      </div>
                    </el-tooltip>
                  </div>
                  <p style="margin-bottom: 0px; margin_left: 6px">
                    企业微信扫码，快捷登录
                  </p>
                  <div class="wrap_logincode">
                    <!-- <div class="codemazheban">
											扫码暂未开放使用
										</div> -->
                    <!-- <img src="../assets/login_code.png" alt=""> -->
                    <span id="show_code"></span>
                    <a
                      class="bg_download"
                      target="_blank"
                      href="https://work.weixin.qq.com/#indexDownload"
                      >点击下载企业微信安装包</a
                    >
                  </div>
                  <!-- <div class="wrap-scand"><img src="../assets/scand.png" alt="">打开企业微信扫一扫登录</div> -->
                </div>
              </transition>
              <!-- 重置密码登录页 -->
              <transition name="el-zoom-in-center">
                <div class="login_forgetpaw" v-show="login_forgetpaw">
                  <div class="clo_code">
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="扫码登录更便捷"
                      placement="left-start"
                    >
                      <div @click="turn_scand">
                        <img src="../assets/half_code.png" alt="" />
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="clo_login_title">重置密码</div>
                  <el-form
                    class="formReset"
                    ref="resetPawForm"
                    :model="resetPawForm"
                    :rules="rulseReset"
                  >
                    <div>
                      <el-form-item prop="pwd_userno">
                        <el-input
                          placeholder="电话"
                          v-model="resetPawForm.pwd_userno"
                          clearable
                        >
                          <template slot="prepend"
                            ><i class="iconfont icon-user1"></i
                          ></template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="login_paw">
                      <el-form-item prop="pwd_userpwd">
                        <el-input
                          placeholder="重置密码"
                          v-model="resetPawForm.pwd_userpwd"
                          type="password"
                          clearable
                        >
                          <template slot="prepend"
                            ><i class="iconfont icon-lock1"></i
                          ></template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div class="yanzhen_code" style="position: relative">
                      <el-input placeholder="输入验证码" v-model="pwd_code">
                        <template slot="prepend"
                          ><i class="iconfont icon-123"></i
                        ></template>
                      </el-input>
                      <el-button
                        @click="get_message_code('resetPawForm')"
                        style="position: absolute; top: 0; right: 0; z-index: 2"
                        :disabled="code_isdisable"
                        >{{ yanzhengname }}</el-button
                      >
                    </div>
                  </el-form>
                  <div class="login_btn">
                    <el-button type="primary" @click="resetPwd_login"
                      >确定</el-button
                    ><!-- @click="resetPwd_login" -->
                  </div>
                </div>
              </transition>
              <!-- 重置密码登录页end -->
              <!-- 没有权限提示框 -->
              <div class="right_hint" v-show="user_right_hint" style="">
                <p>提示</p>
                <p>您还没有系统权限哦!</p>
                <div>
                  <el-button @click="user_right_hint = false">取 消</el-button>
                  <el-button type="primary" @click="user_right_hint = false"
                    >确定</el-button
                  >
                </div>
              </div>
              <!-- 没有权限提示框end -->

              <!-- 没有登录提示框 -->
              <div class="login_hint" v-show="login_right_hint" style="">
                <p style="text-align: right; margin-top: 4px">
                  <i
                    @click="login_right_hint = false"
                    class="el-icon-close"
                  ></i>
                </p>
                <p>请先扫码加入爱恋珠宝企业后进入哦！</p>
                <p class="wrap_loginImg">
                  <img src="../assets/login_code.png" alt="" />
                </p>
              </div>
              <!-- 没有登录提示框end -->
            </div>
          </div>
        </transition>
      </div>
      <div class="beian" v-show="show2">
        <a href="http://www.beian.miit.gov.cn">&copy;蜀ICP备06023048号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      isactive: "",
      loginUrl2020: API.loginUrl2020,
      datatime: "",
      boxtype: false,
      show: false,
      show2: false,
      seciphone: "", //登录成功返回给首页的加密手机号
      login_forgetpaw: false,
      /* 控制忘记密码块是否显示 */
      login_normal: false,
      /* 控制默认登录块是否显示 */
      login_scandnormal: true,
      /* 控制默认登录块是否显示 */
      user_right_hint: false,
      /* 没有权限提示框 */
      login_right_hint: false,
      /* 没有登录提示框 */
      resetPawForm: {
        pwd_userno: "",
        /* 重置密码页的手机号 */
        pwd_userpwd: "",
        /* 重置密码页的密码 */
      },
      rulseReset: {
        pwd_userno: {
          required: true,
          message: "请输入用户名",
          trigger: "change",
        },
        pwd_userpwd: {
          required: true,
          message: "请输入新密码",
          trigger: "change",
        },
      },

      pwd_code: "",
      /* 重置密码页的验证码 */
      yanzhengname: "获取验证码",
      code_isdisable: false,
      middle_result: "", //中转页传过来的用户有没有登录信息。
      iphone_code: "", //中转页传过来的加密手机号
      exaple0: "",
      ruleFormLogin: {
        //密码登录字段
        userno: "",
        /* 密码登录的手机号/用户名 */
        userpwd: "",
        /* 密码登录的密码 */
      },
      RulesLogin: {
        userno: { required: true, message: "请输入用户名", trigger: "blur" },
        userpwd: { required: true, message: "请输入密码", trigger: "blur" },
      },
      loginloading: false, //登陆loading
    };
  },

  components: {},
  computed: {},
  created: function () {
    localStorage.hfkeyid = "";
    localStorage.hfkeypath = "";
    let gloo = this.btnlogin();
    // console.log(gloo);
    if (gloo != "Chrome") {
      this.boxtype = true;
    }
    var savertime = new Date(
      $.ajax({ async: false, cache: false }).getResponseHeader("Date")
    )
      .toLocaleDateString()
      .replace(/\//g, "-");
    this.datatime = savertime;
  },
  mounted: function () {
    var myDate = new Date();
    this.getCurrentDate();
    let _this = this;
    this.show_codes();
    this.getMiddleCode();
    setTimeout(() => {
      _this.show = true;
    }, 500);
    setTimeout(() => {
      _this.show2 = true;
    }, 700);
    //  console.log()
  },
  watch: {
    middle_result: function (val, oldval) {
      // console.log("val--", val);
      if (val == "65302") {
        this.login_right_hint = true;
      }
    },
    //       iphone_code:function(val,oldval){
    //           console.log("val--",val);
    // 　　　　　　if(val){
    //             this.login_right_hint=true;
    //           }
    // 　　　　 },
  },
  /* watch */

  methods: {
    //获取当前时间
    getCurrentDate() {
      var timeStr = "-";
      var curDate = new Date();
      var curYear = curDate.getFullYear(); //获取完整的年份(4位,1970-????)
      var curMonth = curDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
      var curDay = curDate.getDate(); //获取当前日(1-31)
      var curWeekDay = curDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      var curHour = curDate.getHours(); //获取当前小时数(0-23)
      var curMinute = curDate.getMinutes(); // 获取当前分钟数(0-59)
      var curSec = curDate.getSeconds(); //获取当前秒数(0-59)
      var Current =
        curYear +
        timeStr +
        curMonth +
        timeStr +
        curDay +
        " " +
        curHour +
        ":" +
        curMinute +
        ":" +
        curSec;
      //获取服务器时间
      var benditime = new Date(curDate)
        .toLocaleDateString()
        .replace(/\//g, "-");
      // var savertime = new Date($.ajax({async: false}).getResponseHeader("Date")).toLocaleDateString().replace(/\//g, '-');
      // this.datatime = savertime;
      console.log(benditime + "==" + this.datatime);
      if (benditime != this.datatime) {
        this.$alert(
          "当前电脑时间与网络时间不一致，请调整本地电脑时间为当天时间",
          "警告！",
          {
            confirmButtonText: "确定",
            type: "warning",
            callback: (action) => {
              return false;
            },
          }
        );
      }
    },
    //扫码登陆
    show_codes() {
      window.WwLogin({
        id: "show_code",
        appid: "ww28bec14dd8939eae",
        agentid: API.SAO_AGENTID,
        redirect_uri: API.SAO_URL,
        state: "",
        href: "https://userinfo.myailand.org/login_code.css",
      });
    },
    btnlogin: function () {
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var s;
      (s = ua.match(/msie ([\d.]+)/))
        ? (Sys.ie = s[1])
        : (s = ua.match(/firefox\/([\d.]+)/))
        ? (Sys.firefox = s[1])
        : (s = ua.match(/chrome\/([\d.]+)/))
        ? (Sys.chrome = s[1])
        : (s = ua.match(/opera.([\d.]+)/))
        ? (Sys.opera = s[1])
        : (s = ua.match(/version\/([\d.]+).*safari/))
        ? (Sys.safari = s[1])
        : 0;
      if (Sys.ie) return "IE";
      if (Sys.firefox) return "Firefox";
      if (Sys.chrome) return "Chrome";
      if (Sys.opera) return "Opera";
      if (Sys.safari) return "Safari";

      // if(navigator.userAgent.indexOf("MSIE")>0) {                                 // MSIE内核
      // 		return "MSIE";
      // 	}
      // if(navigator.userAgent.indexOf("Firefox")>0){                                 // Firefox内核
      // 		return "Firefox";
      // 	}
      // if(navigator.userAgent.indexOf("Opera")>0){                                  // Opera内核
      // 		return "Opera";
      // 	}
      // if(navigator.userAgent.indexOf("Safari")>0) {                                  // Safari内核
      // 		return "Safari";
      // 	}
      // if(navigator.userAgent.indexOf("Camino")>0){                                  // Camino内核
      // 		return "Camino";
      // 	}
      // if(navigator.userAgent.indexOf("Gecko")>0){                                    // Gecko内核
      // 		return "Gecko";
      // 	}
    },
    downloadbox: function () {
      //下载浏览器跳转地址
      window.location.href =
        "https://dl.softmgr.qq.com/original/Browser/72.0.3626.119_chrome_installer-1.exe";
    },
    turn_scand() {
      /* 点击跳转到扫码登录页 */
      var that = this;
      that.login_normal = false;
      that.login_forgetpaw = false;
      that.login_scandnormal = true;
    },
    turn_forgerpaw() {
      /* 点击跳转到忘记密码页 */
      var that = this;
      that.login_forgetpaw = true;
      that.login_normal = false;
      that.login_scandnormal = false;
      that.$refs["ruleFormLogin"].resetFields();
    },
    turn_paw() {
      /* 点击跳转到密码登录页 */
      var that = this;
      that.login_forgetpaw = false;
      that.login_normal = true;
      that.login_scandnormal = false;
      that.$refs["resetPawForm"].resetFields();
      that.pwd_code = "";
    },
    /* 密码登录 */
    password_login(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginloading = true;
          setTimeout(() => {                                                                  //加密狗注释代码
            Button1_onclick();                                                                //加密狗注释代码
          }, 1000);                                                                           //加密狗注释代码

          setTimeout(() => {                                                                  //加密狗注释代码
            if (localStorage.hfkeyid && localStorage.hfkeyid != "") {                         //加密狗注释代码
              let postData = this.qs.stringify({
                version: API.VERSION_NUM,
                username: _this.ruleFormLogin.userno,
                password: _this.ruleFormLogin.userpwd,
                logincode: "pos",
                type: 0,                                                                      //0不要加密狗 1要加密狗  ----加密狗修改项----
              });
              _this
                .axios({
                  url: API.API_TOKEN + "PublicLogin/UserPwd",
                  method: "POST",
                  data: postData,
                })
                .then((res) => {
                  _this.loginloading = false;
                  console.log("密码登录数据成功", res);
                  if (res.data.error_code == "1002") {
                    _this.$message({
                      message: "密码和用户名不能为空",
                      type: "warning",
                    });
                  } else if (res.data.error_code == "65302") {
                    _this.$message({
                      message: "该用户不存在",
                      type: "warning",
                    });
                  } else if (res.data.error_code == 0) {
                    // _this.seciphone = res.data.iphone;
                    localStorage.tnk = res.data.data[0].iphone;
                    localStorage.fzhitype = res.data.data[0].ktokd; //获取是否是直营店
                    localStorage.agenceid = res.data.data[0].agenceid; //控制下柜下拉值---内容
                    //    this.$router.push({path: '/',query:{middle_result:this.user_date.error_code}});
                    setTimeout(() => {
                      _this.show2 = false;
                    }, 300);
                    setTimeout(() => {
                      _this.show = false;
                    }, 800);
                    setTimeout(() => {
                      _this.$router.push({
                        path: "/index",
                        // query: {
                        // 	login_seciphone: this.seciphone
                        // }
                      });
                    }, 1000);
                  } else if (res.data.error_code == "65303") {
                    _this.$message({
                      message: "密码错误或者帐号与加密狗不匹配！",
                      type: "warning",
                    });
                  }
                });
            } else {                                                                            //加密狗注释代码
              _this.loginloading = false;                                                       //加密狗注释代码
            }                                                                                   //加密狗注释代码
          }, 2500);                                                                             //加密狗注释代码
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    /* end */

    /* 获取手机验证码 */
    get_message_code(formName) {
      let _this = this;
      // getCode:function(){
      //     this.code_isdisable = true;
      //     this.auth_time = 30;
      //     var auth_timetimer = setInterval(() => {
      //         this.yanzhengname = "重发" + this.auth_time + "秒";
      //         this.auth_time--;
      //         if(this.auth_time < 0) {
      //             console.log('111')
      //             this.yanzhengname = "获取验证码";
      //             this.code_isdisable = false;
      //             clearInterval(auth_timetimer);
      //             }
      //     }, 1000);
      // };
      /*  */
      let postData = this.qs.stringify({
        version: API.VERSION_NUM,
        phone: _this.resetPawForm.pwd_userno,
      });

      _this.$refs[formName].validate((valid) => {
        if (valid) {
          this.code_isdisable = true;
          this.auth_time = 30;
          var auth_timetimer = setInterval(() => {
            this.yanzhengname = "重发" + this.auth_time + "秒";
            this.auth_time--;
            if (this.auth_time < 0) {
              // console.log('111')
              this.yanzhengname = "获取验证码";
              this.code_isdisable = false;
              clearInterval(auth_timetimer);
            }
          }, 1000);

          _this
            .axios({
              method: "POST",
              url: "http://api.ailand.mobi:4024/defaultversion/MuZhiSms/SendVerifySms",
              data: postData,
            })
            .then((res) => {
              // console.log("密码提交---数据成功", res);
            })
            .catch((res) => {
              // console.log("密码提交---失败", res);
            });
        } else {
          console.log("error submit!!!!");
          return false;
        }
      });
    },
    /* end */
    /* 重置密码提交 */
    resetPwd_login() {
      let _this = this;
      let postData = this.qs.stringify({
        version: "v1",
        userno: _this.resetPawForm.pwd_userno,
        checkcode: _this.pwd_code,
        userpwd: _this.resetPawForm.pwd_userpwd,
      });
      _this
        .axios({
          method: "POST",
          url: "http://api.ailand.mobi:9028/api/v1/ALL_Logins/ResetPwd",
          data: postData,
        })
        .then((res) => {
          if (res.data.error_code == 0) {
            _this.$message({
              message: "密码重置成功，请登录",
              type: "success",
            });
            _this.login_forgetpaw = false;
            _this.login_normal = true;
            _this.$refs["resetPawForm"].resetFields();
            _this.pwd_code = "";
          } else if (res.data.error_code == 2000) {
            _this.$message({
              message: "验证码错误",
              type: "error",
            });
          }
          // console.log("重置密码提交---数据成功", res);
        })
        .catch((res) => {
          // console.log("重置密码提交---失败", res);
        });
    },
    /* end */

    getMiddleCode: function () {
      var _this = this;
      var middle_result = _this.$route.query.middle_result;
      var iphone_code = _this.$route.query.iphone_code;
      _this.middle_result = middle_result;
      _this.iphone_code = iphone_code;
      console.log("middle_result:---------", middle_result);
      console.log("iphone_code:---------", iphone_code);
      localStorage.name = iphone_code;
      console.log(localStorage.name);
    },

    enter() {
      this.isactive = "active";
    },

    leave() {
      this.isactive = "";
    },
  },
  /* methods */
};
</script>
<style scoped>
.wrap_bg {
  width: 100%;
  height: 100%;
}
.img-bg .login_btn .el-button--primary {
  background-color: #4ebbd0;
}
.img-bg {
  width: 100%;
  height: 100%;
  /* background-image: url('../assets/bg_login.jpg'); */
  background-size: 100% 100%;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: flex-start;
}

.bg_top {
  width: 100%;
  height: 50%;
  background-image: url(../assets/bg_login_top.png);
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.bg_download {
  position: absolute;
  width: 100%;
  right: 50%;
  transform: translateX(50%);
  text-align: center;
  bottom: 20px;
  z-index: 1;
}
.bg_download:hover {
  text-decoration: underline;
}

.bg_bottom {
  width: 100%;
  height: 50%;
  background-color: #ddd;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}

.title {
  width: 550px;
  padding: 10px;
  font-size: 40px;
  color: white;
  letter-spacing: 4px;
  position: relative;
  z-index: 99;
  text-align: center;
}
.nav-bg {
  box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.14);
  width: 430px;
  height: 60px;
  background-color: #aacdd6;
  border-radius: 30px;
  position: relative;
  z-index: 99;
  margin: 50px auto;
  font-size: 0;
}
.nav-movebox {
  height: inherit;
  width: 50%;
  text-align: center;
  line-height: 60px;
  position: absolute;
  z-index: 2;
  left: 0;
  background-color: #6fcae5;
  border-radius: 30px;
  box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.14);
  transition: 0.3s all ease-out;
}
.nav-movebox.active {
  transform: translateX(100%);
}
.nav-bg > .btn {
  height: inherit;
  width: 50%;
  text-align: center;
  font-size: 20px;
  color: #fff;
  display: inline-block;
  line-height: 60px;
  position: absolute;
  z-index: 3;
  cursor: pointer;
}
.nav-bg > .btn:last-child {
  right: 0;
  color: #666666;
}
.firstb.active {
  color: #666666;
}
/* .nav-bg>:hover{
		
	} */
/* .nav-bg>.btn::after {
		content: "";
		position: absolute;
		top: 0;
		left: 100%;
		width: 100%;
		height: 100%;
		border-bottom: 2px solid #000;
		opacity: 0;
		transition: all 0.5s;
		width: 50%;
	} */
/* .nav-bg>.btn:nth-child(1):after {
		content: "老版零售系统";
	}
	.nav-bg>.btn:nth-child(2):after {
		content: "新版零售系统";
	} */
/* .nav-bg>.btn:hover::after {
		left: 0%;
		background-color: #6fcae5;
		border-radius: 30px;
		box-shadow:0 2px 10px 1px rgba(0,0,0,.14);
		opacity: 1;
    	color:#fff;
	} */
.nav-bg > .btn:last-child:hover {
  color: #fff;
}
/* .nav-bg>.btn.active::after {
		left: 0%;
		background-color: #6fcae5;
		border-radius: 30px;
		box-shadow:0 2px 10px 1px rgba(0,0,0,.14);
		opacity: 1;
    color:#fff;
	} */

.center_contentBox {
  width: 550px;
  height: 480px;
  background-image: url("../assets/矩形5.png");
  background-size: 100% 100%;
  background-attachment: fixed;
  padding: 20px;
  position: relative;
  /*	margin-top: 59px;*/
  z-index: 10;
}

.login_content {
  width: 100%;
  height: 100%;
  background: white;
  padding: 30px 110px;
  position: relative;
}
.beian {
  z-index: 10;
  position: absolute;
  bottom: 0;
}
a {
  color: #333;
}
a:link {
  color: #333;
}
a:visited {
  color: #333;
}
a:hover {
  color: #000;
}
.login_content > div > div {
  margin-top: 32px;
}

.login_content > div > img {
  width: 85%;
}

.login_normal {
  position: absolute;
  width: calc(100% - 220px);
  left: 110px;
  z-index: 10;
}

.login_sandcode {
  position: absolute;
  width: calc(100% - 220px);
  left: 110px;
  z-index: 10;
}

.clo_code {
  display: flex;
  justify-content: flex-end;
  margin-top: 2px !important;
}

.clo_code img {
  width: 70%;
  float: right;
}

.item {
  margin: 4px;
}

.item[data-v-10d9df09] {
  margin: 0px;
}

.clo_login_title {
  text-align: left;
  padding: 5px 0px;
  border-bottom: 2px solid #e5f8f6;
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: 2px !important;
}

.forgert_box {
  text-align: right;
  color: #4ebbd0;
  margin-top: 16px;
}

.forgert_box > span {
  cursor: pointer;
}

.yanzhen_code {
  display: flex;
  justify-content: space-between;
}

.yanzhen_code button {
  margin-left: 4px;
}

.login_sandcode p {
  text-align: center;
  font-size: 16px;
  margin-top: 4px;
}

.wrap_logincode {
  position: relative;
  margin-top: 1px !important;
}
.login_sandcode .wrap_logincode > img {
  width: 100%;
}

.login_sandcode .wrap-scand {
  text-align: left;
  display: flex;
  align-items: center;
  margin-top: 10px;
  letter-spacing: 1px;
}

.login_sandcode .wrap-scand > img {
  width: 10%;
  margin-right: 10px;
}

.icon-user1,
.icon-lock1,
.icon-123 {
  font-size: 24px;
  /* color: #409fff; */
}

.icon-close-circle-fill {
  color: #4ebbd0;
  font-size: 12px;
}

.right_hint {
  padding: 80px 0px 20px;
}

.login_hint {
  padding: 2px 10px;
}

.right_hint,
.login_hint {
  border: 1px solid rgb(221, 221, 221);
  width: 65%;
  height: 305px;
  background: white;
  position: absolute;
  top: 65px;
  left: 91px;
  z-index: 20;
  text-align: center;
}

.right_hint > p {
  font-size: 16px;
}

.right_hint .el-button {
  padding: 8px 20px;
}

.wrap_loginImg > img {
  width: 65%;
}

.form1 {
  margin-top: 32px;
}

.formReset {
  margin-top: 32px;
}

.codemazheban {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.95);
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  padding-top: 150px;
  z-index: 10;
  display: block;
}

.boxtype_ban {
  position: fixed;
  width: 600px;
  height: 400px;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 100;
  background-color: #fff;
  border: 1px solid #4ebbd0;
}
.boxtype_ban_title {
  width: 100%;
  text-align: center;
  padding: 10px;
  font-size: 16px;
  background-color: #4ebbd0;
  color: #fff;
}
.boxtype_content {
  width: 100%;
  padding: 15px 30px;
}
.banbenbox {
  padding: 0px 10px;
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  color: #7d7d7d;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue